import coopbranches from './coopbranches';
import groupassignment from './groupAssignment';

const groups = {
  coopbranches: coopbranches,
  groupassignment:groupassignment
};
export * from "./groupAssignment/confirmAssignment";
export default groups;
